import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useMap } from 'react-leaflet';
import { visibleZonesMapSelector, zoneDetailViewSelector, zonesSelector } from '../../../features/places/placesSlice';
import { setNeedBounding } from '../../../features/map/mapSlice';

const OsmMapZoneBounder = () => {
    const map = useMap();
    const dispatch = useDispatch();
    const visibleZonesMap = useSelector(visibleZonesMapSelector);
    const zoneDetailView = useSelector(zoneDetailViewSelector);
    const zones = useSelector(zonesSelector)


    useEffect(() => {
        const mapBounder = () => {
            let bounds = [];
            if (zoneDetailView) {
                if (zones[`${zoneDetailView}`]) {
                    if (zones[`${zoneDetailView}`].zone_coords) {
                        if (zones[`${zoneDetailView}`].zone_coords.length > 2) {
                            zones[`${zoneDetailView}`].zone_coords.forEach(zc => {
                                if (!isNaN(parseFloat(zc.lat)) && !isNaN(parseFloat(zc.lng))) {
                                    bounds.push([parseFloat(zc.lat), parseFloat(zc.lng)]);
                                }
                            });
                            map.fitBounds(bounds, { paddingTopLeft: [350, 75], paddingBottomRight: [25, 100] });
                        }
                    }
                }
                dispatch(setNeedBounding(false));
            } else {
                visibleZonesMap.forEach(vz => {
                    if (zones[`${vz}`]) {
                        if (zones[`${vz}`].zone_coords) {
                            if (zones[`${vz}`].zone_coords.length > 2) {
                                zones[`${vz}`].zone_coords.forEach(zc => {
                                    if (!isNaN(parseFloat(zc.lat)) && !isNaN(parseFloat(zc.lng))) {
                                        bounds.push([parseFloat(zc.lat), parseFloat(zc.lng)]);
                                    }
                                });
                                map.fitBounds(bounds, { paddingTopLeft: [350, 75], paddingBottomRight: [25, 100] });
                            }
                        }
                    }
                });
                dispatch(setNeedBounding(false));
            }
        };
        mapBounder();
    }, [dispatch, map, visibleZonesMap, zoneDetailView, zones]);

    return (
        <div></div>
    );
}

export default OsmMapZoneBounder;